import * as React from 'react';
const ResizeContext = React.createContext(null);
export default ResizeContext;
